/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrderDiscount } from './OrderDiscount';
import {
    OrderDiscountFromJSON,
    OrderDiscountFromJSONTyped,
    OrderDiscountToJSON,
    OrderDiscountToJSONTyped,
} from './OrderDiscount';

/**
 * 
 * @export
 * @interface SearchMerchantsPromosResponse
 */
export interface SearchMerchantsPromosResponse {
    /**
     * 
     * @type {Array<OrderDiscount>}
     * @memberof SearchMerchantsPromosResponse
     */
    promos: Array<OrderDiscount>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SearchMerchantsPromosResponse
     */
    merchantsInProximity: Array<string>;
}

/**
 * Check if a given object implements the SearchMerchantsPromosResponse interface.
 */
export function instanceOfSearchMerchantsPromosResponse(value: object): value is SearchMerchantsPromosResponse {
    if (!('promos' in value) || value['promos'] === undefined) return false;
    if (!('merchantsInProximity' in value) || value['merchantsInProximity'] === undefined) return false;
    return true;
}

export function SearchMerchantsPromosResponseFromJSON(json: any): SearchMerchantsPromosResponse {
    return SearchMerchantsPromosResponseFromJSONTyped(json, false);
}

export function SearchMerchantsPromosResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchMerchantsPromosResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'promos': ((json['promos'] as Array<any>).map(OrderDiscountFromJSON)),
        'merchantsInProximity': json['merchantsInProximity'],
    };
}

export function SearchMerchantsPromosResponseToJSON(json: any): SearchMerchantsPromosResponse {
    return SearchMerchantsPromosResponseToJSONTyped(json, false);
}

export function SearchMerchantsPromosResponseToJSONTyped(value?: SearchMerchantsPromosResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'promos': ((value['promos'] as Array<any>).map(OrderDiscountToJSON)),
        'merchantsInProximity': value['merchantsInProximity'],
    };
}

